import { DeliveryItemImage } from '../components/atomic/delivery_items/DeliveryItemImage';
import { Confetti } from '../components/atomic/effects/confetti/Confetti';
import { DeliveryDialogShell } from '../components/composite/delivery_dialog/delivery_dialog_shell/DeliveryDialogShell';
import { Texts } from '../components/composite/delivery_dialog/texts/Texts';
import { isVinylMusicDelivery } from '../../assets/preloadSounds';
import { Button } from './button/Button';
import { OpenedDeliveryItemBackground } from './content/OpenedDeliveryItemBackground';
import { HeaderText } from './header_text/HeaderText';
import type { SuccessDeliveryScreenController } from './SuccessDeliveryScreenController';
import type { SuccessDeliveryScreenModel } from './SuccessDeliveryScreenModelScreen';
import './success_delivery_screen.css';
import type { ScreenViewProps } from '../shared/screenViewProps';

export type SuccessDeliveryScreenViewProps = ScreenViewProps<
  SuccessDeliveryScreenModel,
  SuccessDeliveryScreenController
>;

export function SuccessDeliveryScreenView({
  model,
  controller,
}: SuccessDeliveryScreenViewProps) {
  const vinylInteractive = isVinylMusicDelivery(
    model.giantId,
    model.orderIndex,
  );

  return (
    <DeliveryDialogShell
      className="success-delivery-screen"
      giantName={model.giantId}
      giantIconVariant="badge"
      beforeFrame={<Confetti className="confetti--behind" />}
      afterGiant={<Confetti className="confetti--front" />}
      header={<HeaderText />}
      content={
        <>
          <Texts
            answerText={model.answerText}
            deliveryItemText={model.deliveryItemText}
            showDeliveryItem
            levelNameText={model.levelNameText}
            giantNameText={model.giantNameText}
          />
          <OpenedDeliveryItemBackground />
          <DeliveryItemImage
            giantId={model.giantId}
            orderIndex={model.orderIndex}
            placement="success-delivery"
            onActivate={
              vinylInteractive
                ? controller.handleToggleVinylMusic
                : undefined
            }
          />
        </>
      }
      actions={<Button onClick={controller.handleViewResults} />}
    />
  );
}
